import React from "react";
import "./ContactCardStyles.css"

const ContactCard = () => {
    return (
        <div>
            <div class="contact-me">
                <h2>Get In Touch</h2>
                <h3>contact me for any querris.</h3>
                <p id="bellow-margin">If you want to create your website mail me.</p>
                <a class="btn" href="mailto:parthajitkonwar15@email.com">CONTACT ME</a>
            </div>
        </div>
    )
}

export default ContactCard;
